import api from 'utils/api';

const STATE_KEY = 'qualityControl';

const SET_FEEDBACK = `${STATE_KEY}/SET_FEEDBACK`;
const SET_LOADING = `${STATE_KEY}/SET_LOADING`;

const initialState = {
    feedback: [],
    isLoading: false,
};

const feedbackReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FEEDBACK:
            return {
                ...state,
                feedback: action.feedback,
            };
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};

export default feedbackReducer;


// Action creators

const setFeedback = feedback => ({type: SET_FEEDBACK, feedback});
const setLoading = isLoading => ({type: SET_LOADING, isLoading});

export const fetchFeedback = productId => (dispatch) => {
    dispatch(setLoading(true));
    return api.productionQualityControl.fetch({product_id: productId})
        .then(
            (res) => {
                dispatch(setFeedback(res.results));
                dispatch(setLoading(false));
            },
            (err) => {
                console.error(err);
                dispatch(setLoading(false));
            },
        );
};



// WEBPACK FOOTER //
// ./src/ducks/qualityControl.js